import { Injectable } from '@angular/core';
import { ApolloQueryResult, FetchResult } from '@apollo/client/core';
import { ApiPaths } from '@uigy/app.settings';
import type {
  DeletePcapMutation,
  DeletePcapMutationVariables,
  GetJobQuery,
  GetPcapPlayerFilesQuery,
  PlayPcapsMutation,
  PlayPcapsMutationVariables
} from '@uigy/generated/graphql';
import {
  DeletePcapGQL,
  GetPcapPlayerFilesGQL,
  Job,
  JobFragment,
  Maybe,
  PlayPcapsGQL,
} from '@uigy/generated/graphql';
import { HttpRequestMethod } from '@uigy/shared/enums/http-request-method';
import { UploadFileService } from '@uigy/shared/services/upload-file/upload-file.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PcapPlayerService {
  constructor(
    private getPcapPlayerFilesGQL: GetPcapPlayerFilesGQL,
    private playPcapsGQL: PlayPcapsGQL,
    private deletePcapGQL: DeletePcapGQL,
    private uploadFileService: UploadFileService) {
  }

  public fetchPcapFilesDetails(): Observable<GetPcapPlayerFilesQuery['pcapPlayer']['files']['nodes'][number][]> {
    return this.getPcapPlayerFilesGQL.fetch().pipe(
      map((response: ApolloQueryResult<GetPcapPlayerFilesQuery>) => response?.data?.pcapPlayer.files?.nodes || [])
    );
  }

  public playPcap(data: PlayPcapsMutationVariables): Observable<Maybe<GetJobQuery['job']>> {
    return this.playPcapsGQL.mutate(data).pipe(
      map((response: FetchResult<PlayPcapsMutation>): Maybe<PlayPcapsMutation['playPcaps']> => response?.data?.playPcaps || null),
    );
  }

  public deletePcapFile(data: DeletePcapMutationVariables): Observable<DeletePcapMutation['deletePcap']> {
    return this.deletePcapGQL.mutate(data).pipe(
      map((response: FetchResult<DeletePcapMutation>): DeletePcapMutation['deletePcap'] => response.data!.deletePcap),
    );
  }

  public uploadPcap(formData: FormData): Observable<JobFragment> {
    const file = <File | null>formData.get('uploadedFile');
    if (!file) {
      throw new Error('no property named "uploadedFile" was found in formData');
    }
    return this.uploadFileService.uploadFile<Job>(ApiPaths.pcapFiles, HttpRequestMethod.POST, {body: formData});
  }
}

